import React from "react";
import Landing from "../../../themes";
import { Checkbox, CheckboxProps } from "antd";
import Button from "../../../components/elements/forms/Button2";
import { useNavigate } from "react-router-dom";

const CandidateTerms: React.FC = () => {
  const navigate = useNavigate();
  const onChange: CheckboxProps["onChange"] = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };
  return (
    <Landing className="font-abel">
      <div className="bg-whirl bg-contain">
        <div className="max-w-[1250px] mx-auto px-3 md:py-12 py-8 text-[#000000]">
          <div>
            <h1 className="text-3xl md:text-5xl font-[700] pb-3">
              Candidate Terms and Conditions
            </h1>
            <section className="font-abel my-4">
              <p className="text-[15px] md:text-[20px] pb-4">
                <b>
                  Welcome to 25th and Staffing Ltd (Nigeria) and 25th and
                  Staffing LLC (United States).
                </b>{" "}
                Before submitting your CV or profile, please review and agree to
                the following terms. These ensure fairness, transparency, and
                professionalism throughout our retained search and AI
                recruitment process.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                1. Representation & Use of Technology
              </p>
              <p className="text-[15px] md:text-[20px] pb-4">
                By submitting your CV, you authorize 25th and Staffing Ltd /
                25th and Staffing LLC (“the Firm”) to represent you for suitable
                client opportunities. Our recruitment process may include
                AI-enabled tools to evaluate candidate fit, manage scheduling,
                and enhance matching accuracy. You consent to the use of these
                tools for legitimate recruitment purposes, in compliance with
                applicable data protection laws (NDPR, GDPR, and U.S. privacy
                regulations).
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                2. Professional Conduct, Timeliness & Communication
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                You agree to maintain professionalism and punctuality throughout
                the recruitment process. This includes:
              </p>
              <ul
                typeof="square"
                className="privacy-list text-[15px] md:text-[20px] line-height: 1.5rem; text-[#000000] pb-3"
              >
                <li>
                  Responding promptly to communications, interview invites, and
                  updates.
                </li>
                <li>
                  Providing 24–48 hours’ notice for any withdrawals,
                  reschedules, or offer-related changes.
                </li>
                <li>
                  Ensuring our firm is kept in the loop on all interactions,
                  discussions, and client communications before, during, and
                  after offer acceptance. <b />
                  Failure to communicate in a timely manner or display
                  professionalism may result in withdrawal of representation.
                </li>
              </ul>
              <p className="text-[15px] md:text-[20px] pb-2">
                3. Compensation Accuracy & Package Integrity
              </p>
              <p className="text-[15px] md:text-[20px] pb-4">
                You agree to provide accurate and verifiable details of your
                current and expected compensation. Any changes to your package
                after submission to a client must first be reviewed with your
                recruiter. Unauthorized salary renegotiations, inaccurate
                information, or unapproved discussions may result in suspension
                from active representation.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                4. Background Check & Offer Process
              </p>
              <p className="text-[15px] md:text-[20px] pb-4">
                All shortlisted candidates are required to complete a background
                and reference verification prior to final onboarding. <br />
                Offer letters, terms of employment, or start dates should be
                reviewed through your recruiter or a firm representative before
                acceptance.
                <br />
                You must ensure 25th and Staffing Ltd / LLC is informed of your
                arrival, onboarding progress, and any updates regarding the role
                or offer.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                5. Fee Structure
              </p>
              <p className="text-[15px] md:text-[20px] pb-4">
                All recruitment and placement fees are paid by our clients,
                based on the candidate’s guaranteed first-year compensation.{" "}
                <br />
                Candidates are not responsible for any placement fees, unless
                they voluntarily request optional value-added services such as
                coaching, relocation, or career consultation.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                6. Confidentiality & Good Faith
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                You agree to keep all client-related information confidential
                and not to contact clients directly outside of the firm’s
                managed process. <br />
                All communications, follow-ups, and updates must be conducted in
                good faith through your assigned recruiter or firm contact.{" "}
                <br />
                Failure to comply may result in the termination of
                representation.
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">7. Data Privacy</p>
              <p className="text-[15px] md:text-[20px] pb-4">
                Your data will be securely processed and stored in compliance
                with the Nigeria Data Protection Regulation (NDPR), General Data
                Protection Regulation (GDPR), and U.S. data privacy standards.
                We only retain data for legitimate recruitment and compliance
                purposes. You may review our full Privacy Policy for details on
                data use and retention.
                <span className="ml-1">
                  <a
                    href="https://www.25thandstaffing.com/policy"
                    className="text-[#2D6EEF]"
                  >
                    https://www.25thandstaffing.com/policy
                  </a>
                </span>
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                8. Candidate Consent
              </p>
              <p className="text-[15px] md:text-[20px] pb-2">
                By proceeding, you confirm that:
              </p>
              <ul className="text-[15px] md:text-[20px] line-height: 1.5rem; text-[#000000]">
                <li>
                  <Checkbox
                    onChange={onChange}
                    className="mt-1 mr-1 text-[#2D6EEF]"
                  />{" "}
                  You have read, understood, and agree to the Candidate Terms
                  and Acknowledgment.
                </li>
                <li>
                  <Checkbox
                    onChange={onChange}
                    className="mt-1 mr-1 text-[#2D6EEF]"
                  />{" "}
                  You authorize 25th and Staffing Ltd (Nigeria) and 25th and
                  Staffing LLC (U.S.) to represent you and process your
                  information using AI-enabled tools for legitimate recruitment
                  purposes.
                </li>
              </ul>
              <div className="max-w-[300px] flex items-center mt-4">
                <Button
                  className="bg-[#2D6EEF] text-[#ffffff] md:h-[55px] w-[100%] md:text-[17px] mt-3 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 rounded-lg"
                  title="Proceed"
                  onSubmitHandler={() => navigate(`#`)}
                />
                <div className="w-[20px]"></div>
                <Button
                  className="border border-[#2D6EEF] text-[#2D6EEF] md:h-[55px] w-[100%] md:text-[17px] mt-3 transition-colors shadow-lg hover:shadow-xl transform hover:scale-101 rounded-lg"
                  title="Cancel"
                  onSubmitHandler={() => navigate(`#`)}
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    </Landing>
  );
};

export default CandidateTerms;
